import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useSelector } from 'react-redux';

import { BackrsFormValues } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/App';
import { useAppDispatch } from '@backrs_ui/grow-ui/src/redux/hooks';
import { RootState } from '@backrs_ui/grow-ui/src/redux/store';
import { postAPISurveyResultsNewUser } from '@backrs_ui/grow-ui/src/redux/userResponse/thunks/userResponse.thunk';
import { selectUserSurveyResults } from '@backrs_ui/grow-ui/src/redux/userResponse/userResponse';

import { GeneratingBlueprintPage } from './GeneratingBlueprintPage';

export const GeneratingBlueprintPageContainer = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const surveyResults = useSelector((state: RootState) => selectUserSurveyResults(state));
  const mostRecentUserResponseSet = useSelector(
    (state: RootState) => state.userResponseSet.mostRecentUserResponseSet,
  );

  const { careerPaths, careerPathRoles, careerPathMeanings, careerPathEnjoyments } = useSelector(
    (state: RootState) => state.careerPath,
  );
  const careerQuestions = useSelector((state: RootState) => state.survey.careerQuestions);

  const user = useSelector((state: RootState) => state.user);

  const [isSurveyPosting, setIsSurveyPosting] = useState(false);
  const [isErrorSigningUp, setIsErrorSigningUp] = useState(false);

  useEffect(() => {
    if (!surveyResults) {
      navigate(APP_ROUTE.INTRO);
    }
  }, [surveyResults, navigate]);

  if (!surveyResults) {
    // we will redirect with the useEffect above if we don't have survey results, but need this for TypeScript
    return null;
  }

  const countOfTopMiddle = surveyResults.careerPathSuggestions.filter(
    (suggestion) => suggestion.scoreSection !== 'LOW',
  ).length;

  const handleUnauthenticatedSubmit = async (data: BackrsFormValues) => {
    if (!mostRecentUserResponseSet) {
      return;
    }

    setIsErrorSigningUp(false);
    setIsSurveyPosting(true);

    const resultAction = await dispatch(
      postAPISurveyResultsNewUser({
        userResponseSet: mostRecentUserResponseSet,
        careerQuestions,
        careerPaths,
        careerPathRoles,
        careerPathMeanings,
        careerPathEnjoyments,
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        role: data.role,
      }),
    );

    if (postAPISurveyResultsNewUser.fulfilled.match(resultAction)) {
      navigate(APP_ROUTE.MY_BLUEPRINT);

      setIsSurveyPosting(false);

      return;
    }

    if (postAPISurveyResultsNewUser.rejected.match(resultAction)) {
      setIsSurveyPosting(false);
      console.error(resultAction.payload);
      setIsErrorSigningUp(true);
    }
  };

  return (
    <GeneratingBlueprintPage
      countSuggestedCareerPaths={countOfTopMiddle}
      tier={surveyResults.tier}
      handleUnauthenticatedSubmit={handleUnauthenticatedSubmit}
      isAuthenticated={!!user.user}
      isSurveyPosting={isSurveyPosting}
      isErrorSigningUp={isErrorSigningUp}
    />
  );
};
